import React,
{
	// useState
} from 'react'
import PropTypes from 'prop-types'
// import { useEffect } from 'react'
import { v4 as uuid } from 'uuid'

function PlayComPlanCardMolDetail(props) {
	const {item,postPagoCarac} = props
	// useEffect(()=>{
	// 	console.log("valor de item", item)
	// })
	console.log("valores de item", item.postPagoCarac)
	const {
		caracteristicas,
		filterPostPago,
		fi_NUMERO_CARACTERISTICAS_MOSTRAR,
		fi_ID_TELEVISION,
		fi_ID_TELEFONIA,
		fi_ID_INTERNET,
		fi_PLAN,
		
	} = item

	const searchCharacteristics = (search, TypeFlag = false, Caracteristicas, filterPostPago = null, fi_PLAN) => {
		let id_familia = localStorage.getItem('id_familia')
        if (TypeFlag) {
			const data = Caracteristicas?.length ? Caracteristicas : [];
			const newCaractData = data.filter(function (CaracData) {
				let CaracDESCRIPCION = [], idWS = 0

				CaracDESCRIPCION = CaracData.fc_DESCRIPCION
                
				idWS = CaracData.fi_CARACTERISTICA_WS.toString()
                
                let newCaracToShowTitle = postPagoCarac?.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})
                if (filterPostPago && id_familia !== 'SHO'){
                    if (newCaracToShowTitle !== undefined){
                        CaracData.fc_TITULO = newCaracToShowTitle.fc_TEXTO_MOSTRAR
                        CaracData.fi_MOSTRAR_CRC = CaracData.fc_VALOR === "" ? 0 : newCaracToShowTitle.fi_MOSTRAR_CRC
                        CaracData.fc_CLASE_CRC = newCaracToShowTitle.fc_CLASE_CRC
                        CaracData.fc_CLASE_GENERAL_CRC = newCaracToShowTitle.fc_CLASE_GENERAL_CRC
                    }
                    return CaracDESCRIPCION.indexOf(search) > -1 && newCaracToShowTitle !== undefined
                }else{
                    return CaracDESCRIPCION.indexOf(search) > -1
                }
			})
            let dataToCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC !== 0));
            let dataToNoCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC === 0));
            let CaracDataConcat = []
            CaracDataConcat = dataToCarac.concat(dataToNoCarac)
			// console.log("to search---------- TypeFlag true: fi_PLAN", fi_PLAN, TypeFlag, search, CaracDataConcat)
			return CaracDataConcat
		} else {
			const data = Caracteristicas?.length ? Caracteristicas : [];
			const newCaractData = data.filter(function (CaracData) {
				let CaracDESCRIPCION = [], idWS = 0

				CaracDESCRIPCION = CaracData.fc_DESCRIPCION
				idWS = CaracData.fi_CARACTERISTICA_WS.toString()
                if ( idWS === "0" ){
                    // console.log("idWS:", idWS)
                    return CaracDESCRIPCION.indexOf(search) === -1
                }else{
                    let newCaracToShowTitle = postPagoCarac?.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})

                    if (filterPostPago && id_familia !== 'SHO'){
                        if (newCaracToShowTitle !== undefined){
                            CaracData.fc_TITULO = newCaracToShowTitle.fc_TEXTO_MOSTRAR
                            CaracData.fi_MOSTRAR_CRC = CaracData.fc_VALOR === "" ? 0 : newCaracToShowTitle.fi_MOSTRAR_CRC
                            CaracData.fc_CLASE_CRC = newCaracToShowTitle.fc_CLASE_CRC
                            CaracData.fc_CLASE_GENERAL_CRC = newCaracToShowTitle.fc_CLASE_GENERAL_CRC
                        }
                        return CaracDESCRIPCION.indexOf(search) === -1 && newCaracToShowTitle !== undefined
                    }else{
                        return CaracDESCRIPCION.indexOf(search) === -1
                    }
                }
			})
            let dataToCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC !== 0));
            let dataToNoCarac = newCaractData.filter(f => (f.fi_MOSTRAR_CRC === 0));
            let CaracDataConcat = []
            CaracDataConcat = dataToCarac.concat(dataToNoCarac)
			// console.log("to search---------- TypeFlag false: fi_PLAN", fi_PLAN, TypeFlag, search, CaracDataConcat)
			return CaracDataConcat
		}
	}

	let CharactBlock = searchCharacteristics('Tipo Footer', false, caracteristicas, filterPostPago, fi_PLAN)
	let CharactFooter = searchCharacteristics('Tipo Footer', true, caracteristicas, filterPostPago, fi_PLAN)
    console.log("CharactBlock",CharactBlock)
	let indexBlo = 0;

	return (
		<div className="c25CompPlanCardsFeaturesListSld">
									{
                                        CharactBlock ?
                                            CharactBlock.map((caract, index) => {
												if(caract.fi_ACTIVO !== 0){
													indexBlo++;
												}
												return caract.fc_VALOR.includes("logo") ?
                                                    <dl key={uuid()} className={`${caract?.fc_CLASE_GENERAL_CRC ? caract.fc_CLASE_GENERAL_CRC : 'carac-plan'} cPlanV2DL`} style={(fi_NUMERO_CARACTERISTICAS_MOSTRAR < indexBlo || caract.fi_ACTIVO === 0)  ? {display:'none'} :(fi_ID_INTERNET > 0 || fi_ID_TELEVISION > 0 || fi_ID_TELEFONIA > 0) ? {display:'none'} : {}}>

                                                        <dt>
                                                            <span className={`${caract.fc_VALOR}`}></span>
                                                        </dt>
                                                        <dd>{caract.fc_TITULO}</dd>
                                                    </dl>
                                                    :
                                                    <dl key={uuid()} className={`${caract?.fc_CLASE_GENERAL_CRC ? caract.fc_CLASE_GENERAL_CRC : 'carac-plan'} cPlanV2DL ${caract.fc_CLASE_ICONO && !caract.fc_DESCRIPCION.includes("Redes Sociales") ? 'iconEle' : ''}`} style={(fi_NUMERO_CARACTERISTICAS_MOSTRAR < indexBlo || caract.fi_ACTIVO === 0) ?{display:'none'} :(fi_ID_INTERNET > 0 || fi_ID_TELEVISION > 0 || fi_ID_TELEFONIA > 0) ? {display:'none'} : {}}>

                                                        {
                                                            caract.fc_CLASE_ICONO
                                                                ?
                                                                <dt>
                                                                    {
                                                                        caract.fc_DESCRIPCION.includes("Redes Sociales")
                                                                            ? null
                                                                            :<i className={caract.fc_CLASE_ICONO}></i>
                                                                    }
                                                                    <span>{caract.fc_TITULO}</span>
                                                                </dt>
                                                                :
                                                                <dt>
                                                                    {caract.fc_TITULO}
                                                                </dt>
                                                        }

                                                        {
                                                            caract.fc_DESCRIPCION.includes("Redes Sociales")
                                                                ?
                                                                <dd className={`${caract?.fc_CLASE_CRC ? caract.fc_CLASE_CRC : ''} rs`}>
                                                                    
																			{
																				
																				caract.fc_VALOR.split("|").map((icoRed, index) => (
																					
																						
																							<i className={icoRed} />
																						
																					
																				))
																			}
																		
                                                                </dd>
                                                                :
                                                                <dd className={`${caract?.fc_CLASE_CRC ? caract.fc_CLASE_CRC : ''}`}>{caract.fc_VALOR}</dd>
                                                        }
                                                    </dl>
											})

                                            : null
                                    }
                                    {
                                        CharactFooter ?
                                            CharactFooter.map((caract, index) => {
												if(caract.fi_ACTIVO !== 0){
													indexBlo++;
												}		
                                                return <div key={uuid()} className={`${caract?.fc_CLASE_GENERAL_CRC ? caract.fc_CLASE_GENERAL_CRC : ''} cPlanIconBlock`} style={(fi_NUMERO_CARACTERISTICAS_MOSTRAR < (indexBlo) || caract.fi_ACTIVO === 0) ?{display:'none'} : (fi_ID_INTERNET > 0 || fi_ID_TELEVISION > 0 || fi_ID_TELEFONIA > 0) ? {display:'none'} : {}}>
                                                    <span className="iconCircle">
                                                        {
                                                            caract.fc_CLASE_ICONO ?
                                                                <i className={caract.fc_CLASE_ICONO}></i>
                                                                : null
                                                        }

                                                    </span>
                                                    <p>
                                                        <strong> {caract.fc_TITULO}</strong>
                                                        <span> {caract.fc_VALOR}</span>
                                                    </p>
                                                </div>
											})
                                            : null
                                    }

		</div>
	)
}
PlayComPlanCardMolDetail.defaultProps = {
	item: {
		id: "",
		title: "Default Title",
		exelentFor: "",
	}
}

PlayComPlanCardMolDetail.propTypes = {
	item: PropTypes.shape({
		title: PropTypes.string,
		exelentFor: PropTypes.string,
	}),
}
export default PlayComPlanCardMolDetail
